import { useState, useCallback } from "react";

export function useInsightsExportPdf(filename: string) {
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

  const generate = useCallback(async () => {
    try {
      setIsGeneratingPDF(true);
      await new Promise((r) => setTimeout(r, 1000));

      const reportElement = document.querySelector(
        "[data-report-content]",
      ) as HTMLElement | null;
      if (!reportElement)
        throw new Error("Elemento do relatório não encontrado");

      const html2pdf = (await import("html2pdf.js")).default;

      const pdfOptions = {
        margin: [10, 10, 10, 10],
        filename,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          backgroundColor: "#ffffff",
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
      } as const;

      await html2pdf()
        .from(reportElement)
        .set(pdfOptions as any)
        .save();
    } finally {
      setIsGeneratingPDF(false);
    }
  }, [filename]);

  return { isGeneratingPDF, generate };
}
